import { scrollToId } from "./utils";

const links = [
  { label: "How It Works", id: "how-it-works" },
  { label: "What We Fix", id: "leak-map" },
  { label: "Revenue Roadmap", id: "roadmap" },
  { label: "Packages", id: "packages" },
  { label: "FAQ", id: "faq" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-brand-black border-t border-white/8 pt-16 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
          <div>
            <div className="inline-flex rounded-2xl bg-white p-4">
              <img src="/apex-flow-logo.png" alt="Apex Flow AI" className="h-14 w-auto object-contain" />
            </div>
            <p className="mt-5 font-serif text-xl tracking-tight text-white/90">
              Purpose-Driven Growth. <span className="gold-text">Built Around People.</span>
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-gold">Explore</p>
            <ul className="mt-5 space-y-3">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="font-sans text-sm text-white/55 hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-gold">Access</p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href="#final-cta"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId("final-cta");
                  }}
                  data-testid="footer-client-login"
                  className="font-sans text-sm text-white/55 hover:text-white transition-colors"
                >
                  Client Login
                </a>
              </li>
              <li>
                <a href="#" data-testid="footer-privacy" className="font-sans text-sm text-white/55 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" data-testid="footer-terms" className="font-sans text-sm text-white/55 hover:text-white transition-colors">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-white/40">© 2026 Apex Flow AI. All rights reserved.</p>
          <p className="font-sans text-xs text-white/40">Apex Flow AI · Revenue Growth Systems for Service Businesses</p>
        </div>
      </div>
    </footer>
  );
}
